import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { CurrencyFormatPipe } from './currency.pipe';
import { FileSymbolPipe } from './file.symbol.pipe';
import { KeysPipe } from './keys.pipe';
import { PriorityColorPipe, TextPriorityColorPipe } from './priority.color.pipe';
import { ReversePipe } from './reverse.pipe';
import { SanitizerHtmlPipe } from './sanitize.html.pipe';
import { StatusColorPipe } from './status.color.pipe';
import { TextColorPipe } from './text.color.pipe';
import { ToDatePipe } from './to.date.pipe';
import { TrimPipe } from './trim.pipe';
import { SafeUrlPipe } from './safeUrl.pipe';
import { SafeHtmlPipe } from './safeHtml.pipe';
import { AddressPipe } from './address.pipe';
import { StreetPipe } from './street.pipe';
import { MinDatePipe } from './min.date.pipe';
import { RangeDatePipe } from './range.date.pipe';
import { ColumnWidthPipe } from './column.width.pipe';
import { ItemSelectedPipe } from './item.selected.pipe';
import { PageCountPipe } from './page.count.pipe';
import { AccountingIntegrationIconPipe } from './accounting.integration.icon.pipe';
import { ToDateTimePipe } from './to.date.time.pipe';
import { TotalInvoicingPipe } from './total.invoicing.pipe';
import { DisableFormControlNamePipe } from './disable.form.control.name.pipe';
import { PhonePipe } from './phone.pipe';
import { FullNamePipe } from './full.name.pipe';
import { ToSimpleTimePipe } from './to.simple.time.pipe';
import { ToDateMedPipe } from './to.date.med.pipe';
import { ServiceConnectionIconPipe } from './service.connection.icon.pipe';
import { SignaturePipe } from './signature.pipe';
import { AddressTwoLinesPipe } from './address.two.lines.pipe';
import { DisplayTextPipe } from './display.text.pipe';
import { DisplayNumberPipe } from './display.number.pipe';
import { FormGroupAtPipe } from './form.group.at.pipe';
import { SourceIconPipe } from './source.icon.pipe';
import { MediaTypePipe } from './media.type.pipe';
import { TimeSimplePipe } from './time.simple.pipe';
import { ToRecurringJobStatusPipe } from './to.recurring.job.status.pipe';
import { CardColorPipe } from './card.color.pipe';
import { CardColorValuePipe } from './card.color.value.pipe';
import { ResizeImagePipe } from './resize.image.pipe';
import { NotSetPipe } from './not.set.pipe';
import { AbsNumberFormatPipe } from './abs.number.pipe';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';

const PIPES = [
  ReversePipe,
  KeysPipe,
  PriorityColorPipe,
  TextPriorityColorPipe,
  ToDatePipe,
  FileSymbolPipe,
  TextColorPipe,
  TrimPipe,
  SanitizerHtmlPipe,
  StatusColorPipe,
  CurrencyFormatPipe,
  SafeUrlPipe,
  SafeHtmlPipe,
  StreetPipe,
  AddressPipe,
  MinDatePipe,
  RangeDatePipe,
  ColumnWidthPipe,
  ItemSelectedPipe,
  PageCountPipe,
  AccountingIntegrationIconPipe,
  ToDateTimePipe,
  TotalInvoicingPipe,
  DisableFormControlNamePipe,
  PhonePipe,
  ToSimpleTimePipe,
  ToDateMedPipe,
  ServiceConnectionIconPipe,
  SignaturePipe,
  AddressTwoLinesPipe,
  DisplayTextPipe,
  DisplayNumberPipe,
  FormGroupAtPipe,
  SourceIconPipe,
  MediaTypePipe,
  TimeSimplePipe,
  ToRecurringJobStatusPipe,
  CardColorPipe,
  CardColorValuePipe,
  DecimalPipe,
  FullNamePipe,
  ResizeImagePipe,
  FullNamePipe,
  NotSetPipe,
  AbsNumberFormatPipe,
];

@NgModule({
  imports: [
    CommonModule,
    ...PIPES
  ],
  providers: [
    ...PIPES,
  ],
  exports: [
    ...PIPES,
  ]
})
export class PipeModule {

  private static warn = false;

  constructor() {
    if (!PipeModule.warn && ConfigService?.environment?.environment === 'dev') {
      console.warn('PipeModule is deprecated. Import each individual pipe as standalone');
      PipeModule.warn = true;
    }
  }
}
